import { BoxProps, ButtonProps, Box, Button } from "@chakra-ui/react";
import { motion } from "framer-motion";

type MotionBoxTypes = Omit<BoxProps, "transition">;
type MotionButtonTypes = Omit<ButtonProps, "transition">;

export const MotionBox = motion<MotionBoxTypes>(Box);
export const MotionButton = motion<MotionButtonTypes>(Button);
